"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gimigliano": {
    "2c42b5e7": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "skipSearch": false
    }],
    "acqua-del-signore": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cc997d0e": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "skipSearch": false
    }],
    "cavora": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "efbb58ab": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "skipSearch": false
    }],
    "colla": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "387489f7": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "skipSearch": false
    }],
    "corbino": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "63ded617": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "skipSearch": false
    }],
    "cuturelle": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cd3e565b": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "skipSearch": false
    }],
    "porto": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9b55875a": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "skipSearch": false
    }],
    "trearie": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d90d66ca": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "skipSearch": false
    }],
    "umbri": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d94edfd9": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "skipSearch": false
    }],
    "visconte": [{
      "hkey": "54cb3675",
      "slug": "gimigliano",
      "name": "Gimigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;